export const PLATFORM_RELEASE = process.env.PLATFORM_RELEASE as string; // Has to be provided by shell to have the right value
